import Column from '@components/column'
import AppointmentSymptoms from '@commons/cards/appointmentDetails/symptoms'
import AppointmentReports from '@commons/cards/appointmentDetails/reports'
import AppointmentConsultReport from '@commons/cards/appointmentDetails/consultReport'
import { useSelector } from 'react-redux'
const Overview = ({ userAppointment }) => {
  const { data: user } = useSelector((state: any) => state.user)
  return (
    <Column rowGap={20}>
      <AppointmentSymptoms
        symptoms={userAppointment?.appointments?.[0]?.symptoms}
      />
      <AppointmentReports
        reports={userAppointment?.appointments?.[0]?.reports}
      />
      <AppointmentConsultReport
        patientId={userAppointment?.id}
        id={userAppointment?.appointments?.[0]?.id}
        doctorId={user?.id}
      />
    </Column>
  )
}

export default Overview
